import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=37c3cf5d&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports